module.exports = __webpack_public_path__ + "img/Tour Button Closed.da933632.svg";